import React, { useState } from "react";
import AsciiArtFooter from "src/components/p5/AsciiArtFooter";
import AsciiVideo from "src/components/p5/AsciiVideo.jsx";
import TitleBar from "src/components/titleBar/TitleBar";

const DEFAULT_DENSITY_MAPPING_NAME = "codingTrain";

export default function AsciiVideoPage() {
  const [densityMappingName, setDensityMappingName] = useState(DEFAULT_DENSITY_MAPPING_NAME);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDensityMappingName((event.target as HTMLInputElement).value);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-black p-4 z-1">
      <TitleBar />
      <div className="z-0 flex flex-col items-center justify-center">
        <AsciiVideo densityMappingName={densityMappingName} />
      </div>
      <AsciiArtFooter handleRadioChange={handleRadioChange} defaultDensityMappingName={DEFAULT_DENSITY_MAPPING_NAME} currentlySelectedRadio={densityMappingName} />
    </div>
  );
}
